import { createFileRoute } from "@tanstack/react-router";
import { LocationIndex } from "@/components/prayer/LocationIndex";

export const Route = createFileRoute("/jadwal-sholat/lokasi")({
  head: () => ({
    meta: [
      { title: "Indeks Lokasi Jadwal Sholat - Semua Kota Indonesia" },
      { name: "description", content: "Daftar lengkap provinsi, kota, dan kecamatan di Indonesia untuk melihat jadwal sholat. Pilih lokasi Anda." },
      { property: "og:title", content: "Indeks Lokasi Jadwal Sholat" },
      { property: "og:description", content: "Daftar provinsi, kota & kecamatan untuk jadwal sholat." },
      { property: "og:url", content: "https://hari.co.id/jadwal-sholat/lokasi/" },
      { property: "og:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://hari.co.id/jadwal-sholat/lokasi/" }],
  }),
  component: () => <LocationIndex variant="sholat" />,
});